import { render, staticRenderFns } from "./BienImmobilierForm.vue?vue&type=template&id=999030b0"
import script from "./BienImmobilierForm.vue?vue&type=script&lang=js"
export * from "./BienImmobilierForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports